"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Amex = ({ width, height }) => {
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 32 33" },
        react_1.default.createElement(react_native_svg_1.G, { transform: "translate(0 .5)", "fill-rule": "nonzero", fill: "none" },
            react_1.default.createElement(react_native_svg_1.Path, { fill: "none", d: "M0 0h32v32H0z" }),
            react_1.default.createElement(react_native_svg_1.Rect, { fill: "#F2F2F2", x: "1", y: "5", width: "31", height: "23", rx: "3" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "m22.95 14 1.32 1.479L25.681 14H27l-2.071 2.31 1.978 2.31h-1.413l-1.224-1.57-1.413 1.57H18.62V14h4.332zm-.563.924h-2.732v.832h2.355v.924h-2.355v.924h2.637l1.225-1.386-1.13-1.294zM9.578 14l1.79 4.343V14h1.789l1.412 3.142L15.887 14h1.79v4.62h-1.13v-3.603l-1.6 3.603h-.942l-1.601-3.603v3.603h-2.167l-.376-1.016H7.6l-.377 1.016H6L7.977 14h1.601zm-.846.74-.754 1.848h1.507l-.753-1.848z", fill: "#007AC6" }))));
};
Amex.defaultProps = {
    width: 32,
    height: 32,
};
exports.default = react_1.default.memo(Amex);
